"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientDataLoader = void 0;
const core_1 = require("@apitable/core");
class ClientDataLoader {
    loadDatasheetPack(datasheetId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { shareId, templateId, embedId, recordIds, dispatch, getState, needLoad } = options;
            if (!needLoad) {
                return {};
            }
            const state = getState();
            dispatch(core_1.StoreActions.requestDatasheetPack(datasheetId));
            let response;
            try {
                response = yield core_1.StoreActions.fetchDatasheetApi(datasheetId, shareId, templateId, embedId, recordIds);
                if (!response.data.success && state.catalogTree.treeNodesMap[datasheetId]) {
                    dispatch(core_1.StoreActions.deleteNode({ nodeId: datasheetId, parentId: state.catalogTree.treeNodesMap[datasheetId].parentId }));
                }
            }
            catch (e) {
                dispatch(core_1.StoreActions.datasheetErrorCode(datasheetId, core_1.StatusCode.COMMON_ERR));
                throw e;
            }
            if (response.data.success) {
                return response.data.data;
            }
            dispatch(core_1.StoreActions.datasheetErrorCode(datasheetId, response.data.code));
            return null;
        });
    }
    loadDashboardPack(_dashboardId) {
        return Promise.resolve(null);
    }
}
exports.ClientDataLoader = ClientDataLoader;
